module.exports = __webpack_public_path__ + "static/media/colicoli06.5a3762d0.webp";